import { render, staticRenderFns } from "./RatingQuestionnaires.vue?vue&type=template&id=36016dfb"
import script from "./RatingQuestionnaires.vue?vue&type=script&lang=js"
export * from "./RatingQuestionnaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36016dfb')) {
      api.createRecord('36016dfb', component.options)
    } else {
      api.reload('36016dfb', component.options)
    }
    module.hot.accept("./RatingQuestionnaires.vue?vue&type=template&id=36016dfb", function () {
      api.rerender('36016dfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/parameters/RatingQuestionnaires.vue"
export default component.exports